import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppComponent } from '../../app.component';
import { Router } from '@angular/router';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { RespuestaAutenticacion } from '../../_models/respuesta-autenticacion';
import { NavService } from '../../_services/_nav.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Usuario } from '../../_models/usuario';
import { UsuariosService } from '../../_services/usuarios.service';
import {SocialAuthService, GoogleLoginProvider, SocialUser} from '@abacritt/angularx-social-login';
import { Funcionalidad } from '../../_models/funcionalidad';
import { FuncionalidadesService } from '../../_services/funcionalidades.service';
import { TerceroCargoService } from '../../_services/tercero-cargo.service';
import { ContactRolesSolicitudesService } from '../../_services/contact-roles-solicitudes.service';
import { AdjuntoService } from '../../_services/adjunto.service';
import { ContenedorCaidoLoadingComponent } from '../contenedor-caido-loading/contenedor-caido-loading.component';
import { ContenedoresService } from '../../_services/contenedores.service';
import { Subscription, forkJoin } from 'rxjs';
import {AppSettings} from '../../../proyect.conf';
import {ModalValidarUnicoComponent} from '../modal-validar-unico/modal-validar-unico.component';

@Component( {
  selector: 'app-ingreso',
  templateUrl: 'ingreso.component.html',
  styleUrls: [ 'ingreso.component.css' ]

} )

export class IngresoComponent implements OnInit, OnDestroy {

  usuario: string;
  contrasena: string;
  error: string;
  carIngreso = false;
  carGoogle = false;
  secMostrar = 'INGRESO';
  objRecuperarContrasena: any = { correo: null, usuario: null };
  recDatos = false;
  resRecuperacion: RespuestaAutenticacion;
  conFondo: any;
  fondo = 1;
  fonAtributos: any = { minimo: 1, maximo: 7 };
  verGoogle = false;
  ruta = 'dashboard/responsabilidad/' + true;
  jwtHelper: JwtHelperService = new JwtHelperService();
  verDobleValidacion = false;
  qrCode: string;
  secQR = true;
  codIngreso: number;
  validando = false;
  usuTemporal: Usuario;
  esMensajeTexto: boolean;
  token: string;
  codInvalido = false;
  mostrarActualizarContrasena = false;
  subscription?: Subscription;
  user: SocialUser;

  constructor( private appComponente: AppComponent,
               private autServicio: AutenticacionService,
               private router: Router,
               private navServicio: NavService,
               private conServicio: ConfirmationService,
               private usuServicio: UsuariosService,
               private menuServicio: FuncionalidadesService,
               private terCargoServicio: TerceroCargoService,
               private contRolesSolicitudesServicio: ContactRolesSolicitudesService,
               private adjService: AdjuntoService,
               private socAutenticacionServicio: SocialAuthService,
               private diaService: DialogService,
               private contenedoresService: ContenedoresService,
               private authExternalService: SocialAuthService,) {
  }

  async ngOnInit() {
    // this.showModalValidarUnico()
    // tslint:disable-next-line:max-line-length
    // this.qrCode = '<img src=\'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANQAAADUCAYAAADk3g0YAAAAAklEQVR4AewaftIAAAp/SURBVO3BQY7gRpIAQXei/v9l3z7GKQGCWS1pNszsD9ZaVzysta55WGtd87DWuuZhrXXNw1rrmoe11jUPa61rHtZa1zysta55WGtd87DWuuZhrXXNw1rrmoe11jUPa61rfvhI5W+qmFROKiaVqeJEZap4Q2WqOFGZKiaVqeImlS8q3lCZKiaVv6nii4e11jUPa61rHtZa1/xwWcVNKicVb1S8UTGpnFRMFZPKScU/qWJSmSq+UJkq3qi4SeWmh7XWNQ9rrWse1lrX/PDLVN6oeEPli4oTlanii4pJ5QuVmyqmihOVqeJvUnmj4jc9rLWueVhrXfOw1rrmh/+4ii9UpoqpYlKZKk5U3lA5qXhD5aTiDZUTlaniRGWq+C97WGtd87DWuuZhrXXND/9jVKaKk4qbVH6TyknFVDGpTConFScVJyr/nzysta55WGtd87DWuuaHX1bxm1Smiknli4o3Kt5QmSreUJlUpoqp4ouKNyp+U8W/ycNa65qHtdY1D2uta364TOXfrGJSmSomlaliUpkqJpWp4g2VqeKkYlKZKiaVqWJSmSomlaliUpkqJpWp4kTl3+xhrXXNw1rrmoe11jX2B/9DVE4qTlSmiknljYpJ5aTiDZWp4kTl36Tif8nDWuuah7XWNQ9rrWvsDz5QmSomlaniDZWTikllqphUbqqYVP5NKk5Uvqh4Q2WqeENlqjhRmSomlanii4e11jUPa61rHtZa1/zwUcUbKm9UnKhMFV9UvKFyUvGFylRxovJGxRsqX1RMKicVX1RMKr/pYa11zcNa65qHtdY1P3ykclIxqZxUTConFZPKGxWTyhsVb6icVPxNKlPFFypTxUnFGxWTylRxUjGp3PSw1rrmYa11zcNa65ofLquYVKaKE5WpYlKZVE4qTlSmiknlDZWbKk5Upoo3KiaVm1SmiknljYqpYlKZKiaV3/Sw1rrmYa11zcNa65ofLlOZKiaVk4pJ5aRiUjlRmSpuqphUTipOVKaKqeJEZar4omJSmSomlTcqJpUTlanipOI3Pay1rnlYa13zsNa6xv7gF6lMFZPKVHGiMlWcqHxRMan8poo3VN6oOFE5qZhUvqj4TSonFTc9rLWueVhrXfOw1rrmh49U3lA5UTmpmFSmiqliUjmpOKmYVH6TylRxk8pvqnhDZao4UXmjYlKZKr54WGtd87DWuuZhrXWN/cEHKlPFicpUMalMFZPKVPGbVG6qmFSmin+SyhcVJyo3VUwqU8WkclLxxcNa65qHtdY1D2uta374qGJSmSqmijdUpoo3VN6omComlZOKSeULlZOKN1SmiqniDZUvKiaVk4pJZaqYVP6mh7XWNQ9rrWse1lrX/PCXqUwVJxUnKicVJypfVEwqJypTxaTyhspJxYnKScVJxYnKVHFSMam8ofJGxU0Pa61rHtZa1zysta754bKKm1ROKk5Upoo3VE5UpopJ5TdVvFFxovKGylRxojJVTCq/qWJSmSq+eFhrXfOw1rrmYa11jf3BBypTxYnKScWJylQxqUwVX6hMFScqU8WJyknFFypTxRsqU8UbKlPFpPKbKv6mh7XWNQ9rrWse1lrX2B98oHJScaJyU8WkclIxqZxUfKHyN1XcpDJVTCpTxaTyN1WcqEwVXzysta55WGtd87DWuuaHjyomlUnljYo3VL5QmSpOVKaKSWWqeKPiDZUTlTcqJpWpYlI5UXmj4g2Vf5OHtdY1D2utax7WWtf88MsqTlROVKaKE5WTikllUvmi4iaVqeKkYlJ5Q+VEZaqYVE4qJpUTlaniDZWp4jc9rLWueVhrXfOw1rrmh49UpopJZap4o+KNiknlpopJZaqYVKaKSeWk4p9UMalMKm+ovFHxRcWkMlXc9LDWuuZhrXXNw1rrGvuDf5DK31QxqUwVk8pJxRsqv6liUpkqJpWbKk5UflPFGypTxRcPa61rHtZa1zysta754SOVNyqmijdUTiomlUllqjipOFGZKr6omFROKiaVqWJSmSomlS9Upoo3Kv7LHtZa1zysta55WGtd88NHFScqJypfVEwqJxWTylQxqUwV/6SKk4o3VKaKSeWNijcq3lB5o+JvelhrXfOw1rrmYa11zQ+XqUwVb1ScqJxUTConFW+oTBWTyknFpDKpTBWTylQxqdxUMamcqJxUTConFScVk8obFTc9rLWueVhrXfOw1rrmh49UpopJ5aTiROVEZaqYKiaVk4qp4iaVqWJSuaniDZWp4qTipopJZaq4SWWq+OJhrXXNw1rrmoe11jX2BxepnFScqEwVk8pUcaIyVUwqb1RMKicVN6mcVEwqU8Wk8kXFpHJS8YXKVDGpnFRMKlPFFw9rrWse1lrXPKy1rvnhl1VMKlPFicpUcaJyojJVvKEyVbyhMlVMKlPFGyonKicVk8oXFScqU8WkMlVMKl9U3PSw1rrmYa11zcNa65offpnKVDGpnFRMKjepnFS8oTJVTBUnFZPKVHGiMlWcqJxUTCqTyhsqU8UXFW+oTBU3Pay1rnlYa13zsNa65ofLKiaVL1ROKr5QuaniROWNikllqrhJZaqYKiaVqeILlROVqeILlanii4e11jUPa61rHtZa1/xwmcobFZPKVHGiMlVMKl+onKicVJxUTCqTyk0qU8WkcqJyojJVvFExqUwVb6j8TQ9rrWse1lrXPKy1rrE/+AepTBWTylQxqZxUvKFyU8WJylTxN6mcVLyh8kbFpDJVTCpfVEwqU8UXD2utax7WWtc8rLWu+eEylZsqvlCZKiaVqeImlS9UbqqYKiaVE5WTiknljYpJZaqYVKaKSeVvelhrXfOw1rrmYa11zQ8fqUwVJypvqJxUTCpvVJyoTBWTyk0qN1WcqEwVk8pUMalMKlPFpDKpvKFyovJPelhrXfOw1rrmYa11jf3Bf5jKTRWTyhcVk8pJxRsqb1S8oTJVnKicVEwqU8UbKlPFGypTxRcPa61rHtZa1zysta754SOVv6nipOINlZOKN1QmlaliUjlRmSreqJhUpopJZao4UTmpmFTeUJkqTlROKn7Tw1rrmoe11jUPa61rfris4iaVk4pJZaqYVKaKmyomlS8q3qiYVKaKSeWLiknlpGJSOan4omJS+U0Pa61rHtZa1zysta754ZepvFFxk8pUcaIyVUwqU8WkcqJyovKFylTxRsUbKicqU8WJyn/Zw1rrmoe11jUPa61rfvgfVzGpvKEyVbxRcaJyU8WJylQxqUwVk8pUMalMFf8mFZPKTQ9rrWse1lrXPKy1rvnhP05lqvg3UbmpYlKZVKaKqWJSOVGZKiaVLyomlS8qJpW/6WGtdc3DWuuah7XWNT/8sorfVHGiMlVMKicVJyonFZPKScUbFW+oTBUnKpPKVHGiMlVMKm9UTCqTylTxNz2sta55WGtd87DWuuaHy1T+JpWp4o2KN1S+qJhUTlROKiaVqWKqOFF5Q2WqOFF5o2JSmSq+UJkqvnhYa13zsNa65mGtdY39wVrrioe11jUPa61rHtZa1zysta55WGtd87DWuuZhrXXNw1rrmoe11jUPa61rHtZa1zysta55WGtd87DWuuZhrXXN/wGavJv1g5Y1LwAAAABJRU5ErkJggg==\'>';
    this.cambiandoFondo();
    if ( location.search.length > 0 ) {
      const token = location.search.split( 'token=' )[ 1 ];
      const redirect = this.jwtHelper.decodeToken( token );
      this.ruta = '/' + redirect.URL;
    }

    this.autServicio.obtenerTipoValidacion().subscribe( constante => {
      const authGoole = constante[ 'SEGOOF' ];
      const domGoogle = constante[ 'DOMGOO' ];
      if ( authGoole === '1' ) {
        this.verGoogle = true;
      }
      if ( !this.autServicio.estaLogueado() ) {
        this.autServicio.cerrarSesion();
        this.appComponente.actualizarEstadoSesion( false );
      } else {
        this.appComponente.actualizarEstadoSesion( true );
        this.redirigir();
      }
    }, error => {
      console.log( 'Ocurrio un error al consultar el servicio : getValidateTypeValidation' );
      if ( !this.autServicio.estaLogueado() ) {
        this.autServicio.cerrarSesion();
        this.appComponente.actualizarEstadoSesion( false );
      } else {
        this.appComponente.actualizarEstadoSesion( true );
        this.redirigir();
      }
    } );

    this.subscription = this.authExternalService.authState.subscribe((user) => {
      this.user = user;
      this.ingresarRedes(user);
    }, error => {
      console.log(error);
    });
  }

  async ingresar() {
    this.carIngreso = true;
    this.error = null;
    this.token = null;
    const validarContenedoresCaido = await this.contenedoresService.verificarContenedores().toPromise();
    if ( validarContenedoresCaido && !validarContenedoresCaido.status ) {
      this.modalContenedorCaido();
      this.carIngreso = false;
      return;
    }
    this.autServicio.ingresar( this.usuario, this.contrasena ).subscribe( async res => {
      console.error('******** res de inicio de sesión' + res);
      if ( res && res.estado ) {
        const decoded = this.jwtHelper.decodeToken( res.respuesta );
        /**
         * Borrar token de la black list para permitir consumo de servicio
         * */
        const tokenBlackList = await this.autServicio.habilitarToken(decoded.usuarios.idUsuario, res.respuesta).toPromise();
        const usuIngreso = await this.usuServicio.getByIdConToken(decoded.usuarios.idUsuario, res.respuesta ).toPromise();

        if ( usuIngreso && !usuIngreso.indicadorAliado ) {
          this.token = res.respuesta;
          this.pasarSegundaValidacion(usuIngreso);
          this.autServicio.obtenerIpClient().subscribe(data => {
            localStorage.setItem('ipClient', data.ip);
          });
        } else {
          this.error = this.navServicio.buscarMensaje( 'AUTENTICACION.MSG_NOTIENEPERMISOS' );
          this.carIngreso = false;
        }
      } else {
        this.error = res ? res.respuesta : this.navServicio.buscarMensaje( 'AUTENTICACION.MSG_ERRORAUTENTICAR' );
        this.carIngreso = false;
      }

    } );
  }

  estaLogueado() {
    this.appComponente.actualizarEstadoSesion( true );
    this.redirigir();
  }

  redirigir() {
    this.router.navigate( [ this.ruta ] );
  }

  async obtenerToken(token: any) {
    /**
     * Borrar token de la black list para permitir consumo de servicio
     * */
    const decoded = this.jwtHelper.decodeToken(token);
    const tokenBlackList = await this.autServicio.habilitarToken(decoded.usuario.idUsuario, token).toPromise();

    this.autServicio.obtenerIpClient().subscribe(data => {
      localStorage.setItem('ipClient', data.ip);
    });
  }

  singInGoogle(userData: any) {
    this.error = '';
    this.carGoogle = true;
    if (userData && userData.idToken) {
      this.autServicio.ingresarExterno(userData.idToken).subscribe( async res => {
        if (res.estado) {
          const decoded = this.jwtHelper.decodeToken( res.respuesta );
          await this.obtenerToken(this.autServicio.obtenerToken());
          const usuIngreso = await this.usuServicio.getByIdConToken(decoded.usuarios.idUsuario, res.respuesta ).toPromise();
          // this.token = usuIngreso.obtenerToken();
          let usuarioLogueado = null;
          usuarioLogueado = this.jwtHelper.decodeToken(this.autServicio.obtenerToken());
        } else {
          this.error = res.respuesta;
        }
        this.carGoogle = false;
      });
    } else {
      this.error = 'Error al autenticar';
      this.carGoogle = false;
    }

  }

  ingresarRedes( userData: any ) {
    this.token = null;
    this.error = null;
    this.carGoogle = true;
    if ( userData && userData.idToken ) {
      this.autServicio.ingresarExterno( userData.idToken ).subscribe( async res => {
        if ( res.estado ) {
          const decoded = this.jwtHelper.decodeToken( res.respuesta );
          /**
           * Borrar token de la black list para permitir consumo de servicio
           * */
          const tokenBlackList =  await this.autServicio.habilitarToken(decoded.usuarios.idUsuario, res.respuesta).toPromise();
          const usuIngreso = await this.usuServicio.getByIdConToken(decoded.usuarios.idUsuario, res.respuesta ).toPromise();
          // const usuIngreso = decoded.usuarios;
          this.token = res.respuesta;
          this.pasarSegundaValidacion(usuIngreso);
        } else {
          this.error = res.respuesta;
        }
        this.carGoogle = false;
      } );
    } else {
      this.error = this.navServicio.buscarMensaje( 'AUTENTICACION.MSG_ERRORAUTENTICAR' );
      this.carGoogle = false;
    }
  }

  olvidoContrasena( formulario: any ) {
    this.secMostrar = 'RECUPERAR';
    formulario.resetForm();
    this.usuario = null;
    this.contrasena = null;
    this.error = null;
  }

  inicio() {
    this.secMostrar = 'INGRESO';
  }

  regresarRecuperar( formulario: any ) {
    this.secMostrar = 'INGRESO';
    formulario.resetForm();
    this.objRecuperarContrasena.usuario = null;
    this.objRecuperarContrasena.correo = null;

  }

  recuperarContrasena( formulario: any ) {
    let mensaje = '';
    mensaje = this.navServicio.buscarMensaje( 'AUTENTICACION.MSG_CONFIRMACIONRECUPERACIONCONTRASENA' );

    this.conServicio.confirm( {
      message: mensaje,
      accept: () => {
        this.envioContrasenaUsuario( false, formulario );
      }, reject: () => {
      }
    } );
  }

  olvidoUsuario( formulario: any ) {
    formulario.resetForm();
    this.objRecuperarContrasena.usuario = null;
    this.objRecuperarContrasena.correo = null;
  }

  envioContrasenaUsuario( tipo: boolean, formulario: any ) {
    this.recDatos = true;
    if ( tipo ) {
      this.autServicio.olvidarUsuario( this.objRecuperarContrasena.correo ).subscribe( res => {
        this.resRecuperacion = res;
        this.recDatos = false;
        this.secMostrar = 'ENVIADO';
        formulario.resetForm();
      }, error => {
        this.resRecuperacion = error;
        this.recDatos = false;
        this.secMostrar = 'ENVIADO';
      } );
    } else {
      this.autServicio.recuperarContrasena( this.objRecuperarContrasena.correo ).subscribe( res => {
        this.resRecuperacion = res;
        this.recDatos = false;
        this.secMostrar = 'ENVIADO';
        formulario.resetForm();
      }, error => {
        this.resRecuperacion = error;
        this.recDatos = false;
        this.secMostrar = 'ENVIADO';
      } );
    }
  }


  cambiandoFondo() {
    this.conFondo = setInterval( () => {
      this.fondo = Math.floor( Math.random() * ( this.fonAtributos.maximo - this.fonAtributos.minimo + 1 ) ) + this.fonAtributos.minimo;
    }, 5000 );
  }

  confirmarQR() {
    this.secQR = false;
  }

  validarCodigo() {
    this.codInvalido = false;
    this.validando = true;
    if ( this.esMensajeTexto ) {
      this.autServicio.validarMensajeTexto( this.usuTemporal.idUsuario, this.codIngreso ).subscribe( rta => {
        if ( rta.estado ) {
          this.permitirIngreso();
        } else {
          this.codInvalido = true;
          this.validando = false;
        }
      } );
    } else {
      this.autServicio.validarCodigoQR( 'ANA', this.usuario, this.codIngreso ).subscribe( rta => {
        if ( rta && rta.estado ) {
          if ( !this.usuTemporal.indicadorAutenticador ) {
            this.autServicio.actualizarIndicadorAutenticador( this.usuTemporal.idUsuario ).subscribe( ent => {
              if ( ent.estado ) {
                this.permitirIngreso();
              } else {
                this.navServicio.setMesage( 0, {
                  severity: 'info',
                  summary: this.navServicio.buscarMensaje( 'LBL_ERROR' ),
                  detail: this.navServicio.buscarMensaje( 'AUTENTICACION.MSG_ACTUALIZACIONINDICADORAUTENTICADOR' )
                } );
                this.validando = false;
              }
            } );
          } else {
            this.permitirIngreso();
          }
        } else {
          this.codInvalido = true;
          this.validando = false;
        }
      } );
    }

  }

  async permitirIngreso() {
    localStorage.setItem( 'token', this.token );
    this.autServicio.cifrado( this.usuTemporal );

    if ( !this.usuTemporal.indicadorPrimerIngreso ) {
        this.autServicio.actualizarPrimerIngreso( this.usuTemporal.idUsuario ).subscribe( estado => {
          if ( estado.estado ) {
            this.cargarMenu();
          } else {
            this.mostrarErrores( 'AUTENTICACION.MSG_ACTUALIZARCARGO' );
          }
        }, error => {
          this.mostrarErrores( 'AUTENTICACION.MSG_ACTUALIZARCARGO' );
        } );
    } else {
      this.cargarMenu();
    }
  }

  mostrarErrores( tipo: string ) {
    this.navServicio.setMesage( 0, {
      severity: 'info',
      summary: this.navServicio.buscarMensaje( 'LBL_ERROR' ),
      detail: this.navServicio.buscarMensaje( tipo )
    } );
    localStorage.removeItem( 'token' );
    this.carIngreso = false;
    this.validando = false;
  }
  async pasarSegundaValidacion(usuarioToken: any) {
    this.usuTemporal = usuarioToken;
    if ( this.usuTemporal && this.usuTemporal.indicadorCambioContrasena ) {
      this.conServicio.confirm( {
        message: 'Su contraseña ha vencido, por favor actualizarla',
        header: 'Atención',
        key: 'aceptarCambioContra',
        icon: 'fa fa-exclamation-circle',
        accept: () => {
          /** mostrar el componente de actualizar contrasena */
          this.mostrarActualizarContrasena = true;
          this.secMostrar = 'ACTUALIZAR';
        }, reject: () => {
          this.carIngreso = false;
        }
      } );
    } else if ( this.usuTemporal.indicadorValidacion && this.usuTemporal.indicadorMensaje ) {
      this.esMensajeTexto = true;
      this.secQR = false;
      this.verDobleValidacion = true;
      this.carIngreso = false;
    } else if ( this.usuTemporal.indicadorValidacion && this.usuTemporal.indicadorAutenticador ) {
      this.codIngreso = null;
      this.secQR = false;
      this.verDobleValidacion = true;
      this.esMensajeTexto = false;
      this.carIngreso = false;
    } else if ( this.usuTemporal.indicadorValidacion ) {
      this.autServicio.generarCodigoQR( 'ANA', this.usuario ).subscribe( qr => {
        this.qrCode = `<img src="data:image/png;base64,${qr.qr}">`;
        this.codIngreso = null;
        this.verDobleValidacion = true;
        this.esMensajeTexto = false;
        this.carIngreso = false;
      } );
    } else {
      this.permitirIngreso();
    }
  }

  ngOnDestroy() {
    clearInterval( this.conFondo );
    this.subscription?.unsubscribe();
  }

  authOnShow() {
    setTimeout( function() {
      $( '#valCodigo' ).select().focus();
    }, 500 );
  }

  async cargarMenu() {
    const menu = [];
    const funcionalidades = [];
    const idAdjuntos = [];
    const lisAdjuntos: any = localStorage.getItem( 'adjuntosMenu' );
    let arregloAdjuntos = lisAdjuntos ? JSON.parse( lisAdjuntos ) : [];
    forkJoin( this.menuServicio.obtenerPermisos() ).subscribe( async( [ menus ] ) => {
      const llavMenu = Object.keys( menus );
      llavMenu.map( ( s: string ) => {
        const datos = menus[ s ];
        const b = new Funcionalidad();
        b.codigo = s;
        b.idFuncionalidad = datos.idMenu;
        b.clase = datos.clase;
        b.idPadre = datos.idPadre;
        b.ruta = datos.ruta;
        b.menu = datos.menu;
        b.secuencia = datos.secuencia;
        b.indicadorDinero = datos.indicadorDinero;
        b.indicadorWeb = datos.indicadorWeb;
        b.nombreIconoMovil = datos.nombreIconoMovil;
        b.idAdjunto = datos.iconoMovil;
        const hijos = datos.hijos;
        if ( hijos && b.indicadorWeb ) {
          const llavHijos = Object.keys( hijos );
          llavHijos.map( ( hijo: string ) => {
            const datoHijo = hijos[ hijo ];
            const nueHijo = new Funcionalidad();
            nueHijo.codigo = hijo;
            nueHijo.idFuncionalidad = datoHijo.idMenu;
            nueHijo.agregar = datoHijo.agregar;
            nueHijo.ver = datoHijo.ver;
            nueHijo.editar = datoHijo.editar;
            nueHijo.clase = datoHijo.clase;
            nueHijo.idPadre = datoHijo.idPadre;
            nueHijo.ruta = datoHijo.ruta;
            nueHijo.menu = datoHijo.menu;
            nueHijo.secuencia = datoHijo.secuencia;
            nueHijo.indicadorDinero = datoHijo.indicadorDinero;
            nueHijo.indicadorWeb = datoHijo.indicadorWeb;
            nueHijo.mostrar = datoHijo.mostrar;
            nueHijo.nuevo = ( nueHijo.clase.search( 'new' ) > 0 ) ? true : false;
            nueHijo.idAdjunto = datoHijo.iconoMovil;
            if ( nueHijo.ver && nueHijo.indicadorWeb ) {
              funcionalidades.push( nueHijo );
              if ( nueHijo.mostrar ) {
                b.hijos.push( nueHijo );
                this.validarAdjunto( nueHijo, arregloAdjuntos, idAdjuntos );
              }
            }
          } );
        }

        if ( b.hijos && b.hijos.length > 0 ) {
          this.validarAdjunto( b, arregloAdjuntos, idAdjuntos );
          menu.push( b );
        }

      } );

      menu.sort( function( x, y ) {
        return x.secuencia - y.secuencia;
      } );

      menu.map( ( s: Funcionalidad ) => {
        s.hijos.sort( function( x, y ) {
          return x.secuencia - y.secuencia;
        } );
      } );

      if ( idAdjuntos.length > 0 ) {
        let adjuntos = [];
        try {
          adjuntos = await this.adjService.obternerPorIdsSinToken( idAdjuntos.map( s => s.idAdjunto ), this.token ).toPromise();
        } catch ( e ) {
        }
        idAdjuntos.forEach( e => {
          const nueAdj = adjuntos.find( y => y.idAdjunto === e.idAdjunto );
          if (nueAdj) {
            arregloAdjuntos.push( nueAdj );
            e.adjunto = nueAdj;
          }
        } );
      }

      arregloAdjuntos = arregloAdjuntos.filter( x => !!funcionalidades.find( y => y.idAdjunto === x.idAdjunto ) || !!menu.find( y => y.idAdjunto === x.idAdjunto ) );
      if (arregloAdjuntos.length > 0 )
        arregloAdjuntos = this.eliminarCampo( arregloAdjuntos, 'adjuntoReporteBase64' );
      localStorage.setItem( 'adjuntosMenu', JSON.stringify( arregloAdjuntos ) );


      localStorage.setItem( 'menu', JSON.stringify( menu ) );
      localStorage.setItem( 'funcionalidades', JSON.stringify( funcionalidades ) );

      const rolesUsuarios = this.autServicio.obtenerRolesUsuarios();
      const nivel = this.autServicio.obtenerNivelMaximo();
      const zona = this.autServicio.obtenerZona();

     /* if ( nivel == 1 && (zona && zona !== '0') ) {
        this.ruta = 'gen/ejecutivo/responsabilidad/' + true;
      } *//*else if ( rolesUsuarios.find( x => conSolicitudesRoles.find( y => y.codigoRol == x && y.indicadorHabilitado ) ) ) {
        this.ruta = 'gcc/centro-llamadas';
      }*/
      this.estaLogueado();
      this.carIngreso = false;
      this.validando = false;
    }, error => {
      this.mostrarErrores( 'AUTENTICACION.MSG_GENERARMENU' );
    } );

  }

  eliminarCampo(data, campo: string) {
    return data.map(item => {
      if (item.hasOwnProperty(campo)) {
        delete item[campo];
      }
      return item;
    });
  }

  cambiarSeccion(seccion?: string) {
    // se limpian los campos y se carga la seccion de INGRESO
    this.usuario = null;
    this.contrasena = null;
    this.carIngreso = false;
    this.error = null;
    this.secMostrar = seccion;
  }

  validarAdjunto( nueHijo: Funcionalidad, arregloAdjuntos: any[], idAdjuntos: any[] ) {
    if ( nueHijo.idAdjunto && nueHijo.idAdjunto !== '0') {
      const adjSeleccionado = arregloAdjuntos.find( y => y.idAdjunto === nueHijo.idAdjunto );
      if ( adjSeleccionado ) {
        nueHijo.adjunto = adjSeleccionado;
      } else {
        idAdjuntos.push( nueHijo );
      }
    }
  }

  modalContenedorCaido() {
    const modal = this.diaService.open(ContenedorCaidoLoadingComponent, {
      header: this.navServicio.buscarMensaje('LBL_AVISO'),
      width: '40%',
      closeOnEscape: true,
      closable: true,
      data: {}
    });
    modal.onClose.subscribe((data: any) => {
    });
  }

  showModalValidarUnico() {
    const modal = this.diaService.open( ModalValidarUnicoComponent, {
      closeOnEscape: false,
      closable: false,
      data: {}
    } );
    modal.onClose.subscribe( ( data: any ) => {
    } );
  }

}
